import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import { history } from 'store';
import {
  ASYNC_CREATE_PROFILE,
  ASYNC_EDIT_PROFILE,
  ASYNC_DELETE_PROFILE,
  ASYNC_RESTORE_PROFILE,
  LOADING
} from 'store';

function* createProfile({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.post, 'profiles', payload);

    yield call(history.push, '/profiles');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editProfile({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.put, `profiles/${payload.id}`, payload);

    yield call(history.push, '/profiles');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* deleteProfile({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.delete, `profiles/${payload.id}`);

    yield call(history.push, '/refresh');
    yield call(history.push, '/profiles');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* restoreProfile({ payload: { id } }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.get, `profiles/restore/${id}`);

    yield call(history.push, '/refresh');
    yield call(history.push, '/profiles/trash');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

export default function* root() {
  yield all([
    takeLatest(ASYNC_CREATE_PROFILE, createProfile),
    takeLatest(ASYNC_EDIT_PROFILE, editProfile),
    takeLatest(ASYNC_DELETE_PROFILE, deleteProfile),
    takeLatest(ASYNC_RESTORE_PROFILE, restoreProfile)
  ]);
}
